/**
 * Powered-by Pleasurealm credit line. Renders subtly on every page.
 * Use the `subtle` variant on the art cover so it doesn't fight the artwork.
 */
export const PoweredBy = ({ subtle = false, className = "" }) => {
  if (subtle) {
    return (
      <div
        data-testid="powered-by"
        className={`kb-mono-label text-[10px] tracking-[0.32em] text-[var(--kb-fg-2)] opacity-60 ${className}`}
      >
        POWERED BY{" "}
        <span className="text-[var(--kb-fg)] font-semibold">PLEASUREALM LTD</span>
      </div>
    );
  }
  return (
    <div
      data-testid="powered-by"
      className={`kb-mono-label text-[var(--kb-fg-2)] ${className}`}
    >
      POWERED BY{" "}
      <span className="text-[var(--kb-fg)] font-semibold">PLEASUREALM LTD</span>
    </div>
  );
};
